import Router from 'next/router';

type Parameter = { [key: string]: string | number | null | undefined };
type Resolver = (value: unknown) => void;

interface QueueItem {
  parameter: Parameter;
  resolver: Resolver;
}

const queue: Array<QueueItem> = [];

let queueRunning = false;

export function replaceUrl(parameter: Parameter) {
  return new Promise(resolver => {
    queue.push({
      parameter,
      resolver,
    });
    if (!queueRunning) {
      void nextQueue();
    }
  });
}

async function nextQueue() {
  queueRunning = true;
  const items = queue.splice(0);
  if (items.length > 0) {
    await run(items);
    await nextQueue();
    return;
  }
  queueRunning = false;
}

async function run(items: Array<QueueItem>) {
  const parameter = mergeParams(items.map(i => i.parameter));
  const url = new URL(location.href);

  Object.keys(parameter).forEach(key => {
    const value = parameter[key];
    if (value) {
      url.searchParams.set(key, value.toString().toLowerCase());
    } else {
      url.searchParams.delete(key);
    }
  });

  await Router.replace(
    {
      pathname: url.pathname,
      query: url.searchParams.toString(),
    },
    undefined,
    { shallow: true }
  );
  items.forEach(({ resolver }) => {
    resolver(undefined);
  });
}

const mergeParams = (arr: Array<Parameter>) => {
  return arr.reduce((agg, p) => {
    return { ...agg, ...p };
  }, {});
};
